/// <amd-module name="Wit/Common/WorkItemControls/DatePickerDialog" />
import * as React from "react";
import { useState } from "react";
import { DatePicker } from "VSSUI/DatePicker";
import { Dialog } from "VSSUI/Dialog";
import * as Resources from "Wit/Common/WorkItemControls/Resources";

export interface IDatePickerDialog {
    onDismiss: (date?: Date) => void;
}

export function DatePickerDialog(props: IDatePickerDialog) {
    const [date, setDate] = useState<Date | undefined>();

    return (
        <Dialog
            titleProps={{ text: Resources.SelectDate }}
            onDismiss={() => props.onDismiss}
            footerButtonProps={[
                {
                    text: Resources.Cancel,
                    onClick: () => props.onDismiss()
                },
                {
                    text: Resources.Ok,
                    onClick: () => props.onDismiss(date),
                    primary: true
                }
            ]}
        >
            <div className="scroll-auto flex-grow flex-row">
                <DatePicker
                    containerClassName="full-width"
                    onChange={value => {
                        setDate(value);
                    }}
                    value={date}
                />
            </div>
        </Dialog>
    );
}
